import { useRef } from 'react'

// Inline SVG icons — no external asset dependency
const CameraIcon = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
   </svg>
)

// Placeholder silhouette when no photo is set
const PlaceholderSVG = () => (
   <svg
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
         width: '88px',
         height: '88px',
         borderRadius: '50%',
         display: 'block',
      }}>
      <circle cx="44" cy="44" r="44" fill="#2c2c31" />
      <circle cx="44" cy="36" r="14" fill="#3a3a3f" />
      <ellipse cx="44" cy="72" rx="22" ry="16" fill="#3a3a3f" />
   </svg>
)

function Photo({ preview, handleValue }) {
   const inputRef = useRef(null)

   function upload() {
      inputRef.current.click()
   }

   function handleSelectedFile(e) {
      const file = e.target.files[0]
      if (file) {
         const url = URL.createObjectURL(file)
         handleValue(url, 'photo')
      }
   }

   return (
      <div className="group-photo">
         <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleSelectedFile}
            style={{ display: 'none' }}
         />

         <div className="photo-wrapper" onClick={upload} title="Upload photo">
            {preview ? (
               <img className="photo" src={preview} alt="Profile" />
            ) : (
               <PlaceholderSVG />
            )}
            <div className="photo-overlay">
               <CameraIcon />
            </div>
         </div>

         <p className="photo-hint">Click to upload photo</p>
      </div>
   )
}

export default Photo
